import { FilterImpl } from "liquidjs/dist/template";

import { parseTextAndUrlSegments, replaceURLs } from "@stw/extract-urls";

export default function addRefcode2w(this: FilterImpl, value: unknown): string {
  const strValue = String(value);
  const refcode = this.context.getSync(["refcode2w"]) as string | undefined;

  if (!refcode) {
    throw new Error(
      `add_refcode2w filter requires a refcode to be set in the global context`
    );
  }

  return replaceURLs(parseTextAndUrlSegments(strValue), url => {
    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set("refcode2w", refcode);
      return decodeURI(urlObj.href);
    } catch (_e) {
      return url;
    }
  }).join("");
}
